import ApiService from '../../../shared/services/api-service';
import commonActions from '../../../shared/store/common/action-creators';
import notificationsActionsCreators from '../notifications/action-creators';
import attachmentCommitTypes from './commit-types';

const attachmentActionsCreators = {
  addAttachment(reportGuid) {
    return {
      addingAttachmentFor: reportGuid,
      type: attachmentCommitTypes.SET_ADDING_ATTACHMENT_FOR,
    };
  },
  closeAddAttachment() {
    return {
      addingAttachmentFor: null,
      type: attachmentCommitTypes.SET_ADDING_ATTACHMENT_FOR,
    };
  },
  createAttachment(formData) {
    const post = { ...formData };
    // Remove redundant
    delete post.reportGuid;
    return async (dispatch) => {
      dispatch(this.setIsLoading('createAttachment'));
      const data = await ApiService.post(`/api/v1/reports/${formData.reportGuid}/attachments`, post)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('createAttachment'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.createAttachmentSuccess(data));
      }
    };
  },
  createAttachmentSuccess(created) {
    return (dispatch) => {
      dispatch(this.pushAttachment(created.data));
      dispatch(this.closeAddAttachment());
      dispatch(notificationsActionsCreators.addSavedSuccessfully('Attachment created'));
    };
  },
  deleteAttachment(attachmentGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('deleteAttachment'));
      const data = await ApiService.delete(`/api/v1/attachments/${attachmentGuid}`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('deleteAttachment'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.deleteAttachmentSuccess(data));
      }
    };
  },
  deleteAttachmentSuccess(deleted) {
    return (dispatch) => {
      dispatch(this.removeAttachment(deleted.data));
      dispatch(notificationsActionsCreators.addSavedSuccessfully('Attachment deleted'));
    };
  },
  pushAttachment(attachment) {
    return {
      attachment,
      type: attachmentCommitTypes.PUSH_ATTACHMENT,
    };
  },
  pushAttachments(attachments) {
    return {
      attachments,
      type: attachmentCommitTypes.PUSH_ATTACHMENTS,
    };
  },
  removeAttachment(deleted) {
    return {
      attachmentGuid: deleted.guid,
      type: attachmentCommitTypes.REMOVE_ATTACHMENT,
    };
  },
  resetAttachmentState() {
    return {
      type: attachmentCommitTypes.RESET_ATTACHMENT_STATE,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: attachmentCommitTypes.SET_ATTACHMENTS_IS_LOADING,
    };
  },
};

export default attachmentActionsCreators;
